import { useRef, useState } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
import { API_PATHS } from "../../../API/api_paths";
import PlayerControls from "./PlayerControls";
import VideoPlayerProps from "./VideoPlayer";

export const VideoPlayer = ({
  video_id,
  video_title,
  video_description,
  duration,
  isViewOnly,
}: VideoPlayerProps.IProps) => {
  const playerRef = useRef(null);
  const [volume, setVolume] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [isVolumeShow, setIsVolumeShow] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState("1x");
  const [isSettingsShow, setIsSettingsShow] = useState(false);

  const handleSeekTo = (time: number) => {
    if (playerRef.current) {
      (playerRef.current as ReactPlayer).seekTo(time, "seconds");
      setCurrentTime(time);
    }
  };

  return (
    <Container
      onClick={() => {
        if (playerRef.current && !isVolumeShow && !isSettingsShow) {
          const newCurrentTime = (
            playerRef.current as ReactPlayer
          ).getCurrentTime();
          setCurrentTime(newCurrentTime);
          (playerRef.current as ReactPlayer).seekTo(newCurrentTime, "seconds");
          setIsPlaying(!isPlaying);
        }
      }}
    >
      <ReactPlayerContainer className="react-player">
        <ReactPlayer
          url={API_PATHS.postVideo.getPostVideo + video_id}
          ref={playerRef}
          width="100%"
          height="100%"
          playing={isPlaying}
          volume={volume}
          onProgress={(progress) => setCurrentTime(progress.playedSeconds)}
          onPause={() => setIsPlaying(false)}
          onPlay={() => setIsPlaying(true)}
          playbackRate={Number(playbackSpeed.split("x")[0])}
        />
        <PlayerControls
          currentTime={currentTime}
          isPlaying={isPlaying}
          volume={volume}
          setVolume={setVolume}
          isVolumeShow={isVolumeShow}
          setIsVolumeShow={setIsVolumeShow}
          handleSeekTo={handleSeekTo}
          isSettingsShow={isSettingsShow}
          setIsSettingsShow={setIsSettingsShow}
          playbackSpeed={playbackSpeed}
          setPlaybackSpeed={setPlaybackSpeed}
          setIsPlaying={setIsPlaying}
          video_title={video_title}
          video_description={video_description}
          duration={duration}
          isViewOnly={isViewOnly}
        />
      </ReactPlayerContainer>
    </Container>
  );
};

const Container = styled.div`
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
const ReactPlayerContainer = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  video {
    display: block;
    border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
    aspect-ratio: 16/9;
  }
`;
